import { Message } from "./Message";

// users/favorites
export class Favorite {
  static COL = 'favorites';
  id: string;
  created: Date = new Date();

  constructor(public msg: Message, public userId: string) {
    this.id = msg.id;
  }
}